import { useMemo } from "react";
import LoadingSpinner from "../../../externalComponents/LoadingSpinner";
import { Text } from "../../../externalComponents/tailwind/text";

export default function ContactKPI({ label, data, fetching, keyRate }) {
  const { value, amount, total, unit } = useMemo(() => {
    if (!data || keyRate === null) {
      return { value: null, amount: null, total: null };
    }

    let numerator = 0;
    let denominator = 1;
    let customTotal = null;
    let customUnit = "%";

    switch (keyRate) {
      case "delivered":
        numerator = null;
        denominator = null;
        customTotal = data.delivered;
        customUnit = "";
        break;
      case "openRate":
        numerator = data.read;
        denominator = data.delivered;
        break;
      case "failedRate":
        numerator = data.failed;
        denominator = data.delivered + data.failed;
        break;
      case "sales":
        numerator = null;
        denominator = null;
        customTotal = data.sales;
        customUnit = "";
        break;
      case "conversionRate":
        numerator = data.sales;
        denominator = data.delivered;
        break;
      case "turnover":
        numerator = null;
        denominator = null;
        customTotal = data.turnover;
        customUnit = "€";
        break;
      default:
        numerator = 0;
        denominator = 1;
    }

    const computedRate =
      numerator !== null && denominator !== null
        ? Math.min(1, numerator / Math.max(1, denominator)) * 100
        : null;

    return customUnit !== "%"
      ? {
          value: customTotal,
          unit: customUnit,
        }
      : {
          value: computedRate !== null ? computedRate.toFixed(2) : null,
          amount: customTotal ?? numerator,
          total: customTotal ?? denominator,
          unit: customUnit,
        };
  }, [keyRate, data]);

  return (
    <div className="my-3 md:my-0 grid-cols-4 sm:border-l overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6 flex flex-col">
      <Text className="text-sm font-medium leading-6 text-gray-500">
        {label}
      </Text>
      {keyRate === null ? (
        <div className="w-full flex-none text-3xl font-medium leading-10 tracking-tight text-gray-900 dark:text-white mt-auto">
          <div className="text-green-600 text-xs font-medium">Coming soon</div>
        </div>
      ) : (
        <>
          {fetching ? (
            <div className="scale-50 mt-2 h-[25px]">
              <LoadingSpinner />
            </div>
          ) : (
            <>
              {value > 0 && (
                <div
                  className="text-green-600 text-xs font-medium"
                  data-testid="quota"
                >
                  {amount === total ? (
                    total
                  ) : (
                    <>
                      {amount}/{total}
                    </>
                  )}
                </div>
              )}
              <div
                className="w-full flex-none text-3xl font-medium leading-10 tracking-tight text-gray-900 dark:text-white mt-auto"
                data-testid="value"
              >
                {value}
                {unit}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}
